<button mat-raised-button color="primary" class="map-toggle" id="{{ buttonId }}" [disabled]="disabled">
  <img [src]="imgSrc" [alt]="(layout === 'map' ? 'Button:HideMap' : 'Button:ShowMap') | translate" />
  {{ (layout === 'map' ? 'Button:HideMap' : 'Button:ShowMap') | translate }}
</button>
